<template lang="pug">
button.toggler(ref="button", type="button")
  span
    slot
  i.fa.fa-fw.fa-chevron-right.ms-1(:class="{ 'fa-rotate-90': opened }")
</template>

<script>
export default {
  props: {
    opened: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="sass">
button.toggler
  i.fa
    transition: transform $duration $timing-function
</style>
